import { transparentize } from "polished";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    background-color: ${colors.white};
    border-radius: 20px;
    overflow: hidden;
    text-align: center;
    height: 100%;
    box-shadow: 0 5px 10px ${transparentize(0.8, "black")};
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    text-align: center;
`;

export const Title = styled.h4`
    font-size: 18px;
`;

export const Copy = styled.p`
    margin: 8px 0 0 0;
    font-size: 13px;
`;

export const Actions = styled.div`
    padding-top: 16px;
`;

export const MobileActionWrapper = styled.div`
    text-align: center;

    p {
        margin: 4px 0 12px 0;
        font-size: 11px;
    }
`;
